export let USERHOMECONSTANTS = {
  otherJobTitle: "Other",
  sorting: {
    ascOrderString: "asc",
    ascIconClass: "fa fa-caret-up pull-right fa-lg",
    descOrderString: "desc",
    descIconClass: "fa fa-caret-down pull-right fa-lg"
  },
  pagination: {
    currentPage: 1,
    itemsPerPage: 15,
    maxSize: 100
  },
  tabs: {
    applications: "Applications",
    tasks: "Tasks",
    messages: "Messages",
    users: "Users"
  },
  tabIds: {
    applicationsId: 0,
    tasksId: 1,
    messagesId: 2,
    myDetailsId: 3,
    usersId: 4,
    preferencesId: 5
  },
  messageStatus: {
    read: "Read",
    unread: "Unread"
  },
  accountStatus: {
    pending: "Pending",
    active: "Active",
    inActive: "InActive"
  },
  taskStatus: {
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected"
  },
  taskTypeCodes: {
    createAccount: "CreateAccount",
    addedOrganisation: "AddedOrganisation",
    applicationAccess: "ApplicationAccess"
  },
   organisationStatus: {
    pending: "Pending",
    active: "Active",
    inActive: "InActive"
  },
  organisationApplicationClaimStatusTypes: {
    pending: "Pending",
    active: "Active",
    inActive: "InActive"
  },
  params: {
    userId: "userId",
    tabId: "tabId",
    detailTabId: "detailTabId",
    accountId: "accountId"
  },
  messages: {
    requestSuccessfull: "Your request has been completed successfully!",
    requestFailed: "Failed to process your request! Please try later...",
    requestUnauthorised: "You do not have permission to submit this request!"
  }
}; 



// WEBPACK FOOTER //
// ./src/app/modules/userHome/userHome.constants.ts